import { useEffect, useState } from "react";
import styled from "styled-components";
import { StyledText } from "styles/Text";
import Dropdown, { DropdownOption } from "./Dropdown";

interface Props {
  options: DropdownOption[];
  selectedValue: number;
  onChangeValue?: (val: number | string) => void;
}

const DropdownPicker = ({ selectedValue, options, onChangeValue }: Props) => {
  const [isShowDropdownPicker, setIsShowDropdownPicker] = useState(false);
  const [currentValue, setCurrentValue] = useState<number>(selectedValue);
  const [currentLabel, setCurrentLabel] = useState<string | undefined>("");

  const handleValueChage = (e: number | string) => {
    onChangeValue && onChangeValue(e);
    setCurrentValue(Number(e));
    setIsShowDropdownPicker((prev) => !prev);
  };

  useEffect(() => {
    const selectedIndex = options.findIndex(
      (item) => item.value === currentValue,
    );
    if (selectedIndex >= 0) {
      const currentOption = options.find((item) => item.value === currentValue);
      setCurrentLabel(currentOption?.label);
    } else {
      setCurrentLabel("선택");
    }
  }, [currentValue, options]);

  useEffect(() => {
    setCurrentValue(selectedValue);
  }, [selectedValue]);

  return (
    <StyledContainer>
      <StyledLabelButton
        onClick={() => setIsShowDropdownPicker((prev) => !prev)}
      >
        <StyledText.Body13>{currentLabel}</StyledText.Body13>
        <StyledArrowImg
          src={
            isShowDropdownPicker
              ? require("assets/images/bt_close_n.png")
              : require("assets/images//bt_open_n.png")
          }
        />
      </StyledLabelButton>
      <Dropdown
        isOpen={isShowDropdownPicker}
        onChangeValue={handleValueChage}
        selectedValue={currentValue}
        options={options}
      />
    </StyledContainer>
  );
};

export default DropdownPicker;

const StyledContainer = styled.div`
  height: 48px;
  display: flex;
  align-items: center;
  position: relative;
`;

const StyledLabelButton = styled.button`
  display: flex;
  align-items: center;
`;

const StyledArrowImg = styled.img`
  width: 36px;
  height: 36px;
`;
